export default "__VITE_ASSET__qwVPDWFG__"